"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePixelRequestToJSON = exports.UpdatePixelRequestFromJSONTyped = exports.UpdatePixelRequestFromJSON = exports.instanceOfUpdatePixelRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdatePixelRequest interface.
 */
function instanceOfUpdatePixelRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdatePixelRequest = instanceOfUpdatePixelRequest;
function UpdatePixelRequestFromJSON(json) {
    return UpdatePixelRequestFromJSONTyped(json, false);
}
exports.UpdatePixelRequestFromJSON = UpdatePixelRequestFromJSON;
function UpdatePixelRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'domain': !(0, runtime_1.exists)(json, 'domain') ? undefined : json['domain'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.UpdatePixelRequestFromJSONTyped = UpdatePixelRequestFromJSONTyped;
function UpdatePixelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
    };
}
exports.UpdatePixelRequestToJSON = UpdatePixelRequestToJSON;
